import React from "react";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

export default function DateInput({ label, value, setValue }) {
    return (
        <div className="rest-filter-date">
            {label ? (
                <label className="rest-filter-date__label">{label}</label>
            ) : null}
            <DatePicker
                value={value}
                onChange={setValue}
                calendar={persian}
                locale={persian_fa}
                inputClass="rest-filter-date__input"
                containerClassName="rest-filter-date__container"
                portal
                zIndex={10100}
            />
        </div>
    );
}
